import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

export default function SummarizeSentences({ theme, ...props }) {
  return (
    <svg
      className={cx(theme.container, theme[props.svg], props.className)}
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      viewBox="0 0 27 22"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="Argumentative"
        className={theme.stroke}
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Summarize-2"
          transform="translate(-722.000000, -139.000000)"
          fillRule="nonzero"
          stroke="#0A4BB8"
          strokeWidth="2"
        >
          <g id="SS" transform="translate(698.000000, 100.000000)">
            <g id="SS-icon" transform="translate(24.000000, 39.000000)">
              <rect
                id="Rectangle-3"
                fill="#FFAA00"
                x="5"
                y="1"
                width="21"
                height="4"
              />
              <rect
                id="Rectangle-3-Copy"
                fill="#43B02A"
                x="1"
                y="9"
                width="21"
                height="4"
              />
              <rect
                id="Rectangle-3-Copy-2"
                fill="#FFFFFF"
                x="5"
                y="17"
                width="21"
                height="4"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

SummarizeSentences.propTypes = {
  svg: PropTypes.string.isRequired,
  theme: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  className: PropTypes.string,
}
